const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20portrait%20of%20a%20young%20person%2C%20warm%20tones%2C%20minimalist%20illustration%20style%2C%20circular%20composition%2C%20soft%20lighting%2C%20no%20text%2C%20profile%20picture%20aesthetic&width=100&height=100&seq=comment-avatar-01&orientation=squarish',
    name: '星辰大海',
    time: '2小时前',
    content: '90影院真的太棒了！更新的速度比其他平台快太多了，流浪地球3刚上线就第一时间看了，画质清晰流畅，完全不卡顿。已经推荐给身边所有朋友了！',
    likes: '326',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20portrait%20illustration%2C%20warm%20amber%20tones%2C%20minimalist%20style%2C%20circular%20frame%2C%20soft%20gradient%20background%2C%20profile%20picture%20aesthetic%2C%20no%20text&width=100&height=100&seq=comment-avatar-02&orientation=squarish',
    name: '光影追梦人',
    time: '5小时前',
    content: '作为一个追了十几年剧的老观众，90影院的片源丰富程度真的让我惊喜。从经典老片到最新热播，应有尽有，而且完全免费，这才是真正的良心网站。',
    likes: '218',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%2C%20warm%20golden%20color%20palette%2C%20illustration%20style%2C%20circular%20composition%2C%20soft%20lighting%2C%20profile%20picture%2C%20no%20text&width=100&height=100&seq=comment-avatar-03&orientation=squarish',
    name: '周末影迷',
    time: '8小时前',
    content: '最喜欢90影院的专题合集功能，按类型整理得特别清晰。周末宅家一口气刷完了悬疑片单，每一部都好看，省去了到处找片的时间，体验满分！',
    likes: '157',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20portrait%20illustration%20with%20warm%20tones%2C%20minimalist%20aesthetic%2C%20circular%20frame%2C%20soft%20amber%20lighting%2C%20profile%20picture%20style%2C%20no%20text&width=100&height=100&seq=comment-avatar-04&orientation=squarish',
    name: '动漫控',
    time: '12小时前',
    content: '鬼灭之刃更新第一时间就有了，画质超赞！作为一个8090后动漫老粉，这里简直就是天堂。希望90影院越做越好，永远支持你们！',
    likes: '482',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            观众热评
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            听听8090观众的真实声音，为什么他们都选择90影院
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto">
          {comments.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="font-heading text-sm font-bold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line text-accent-400"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}